import ProductListSectionThree from './ProductListSectionThree'

export default ProductListSectionThree
export { ProductListSectionThree }
export { ProductListSectionThreeLegacy } from './product-list-section-three-legacy'
export { ProductListSectionThreeDS } from '@src/components/blocks/product-list-section-three-ds'
export type { ProductListSectionThreeProps } from './product-list-section-three.types'
